import { request, METHOD } from '../utils/request.js'


// 新个人锻炼次数趋势
export function selectTestTimeQushiNewFitness(data) {
  return request(
    '/h5Mfitness/newH5Fitness/selectTestTimeQushiNewFitness',
    METHOD.POST,
    data
  )
}

export function selectWeekActivityNewFitness(data) {
  return request(
    '/h5Mfitness/newH5Fitness/selectWeekActivityNewFitness',
    METHOD.POST,
    data
  )
}
